// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js!../shared.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-content {
  background-color: var(--shell-bg-color);
  box-shadow: var(--shadow);
  padding-right: 1rem;
  padding-top: 1rem;
  padding-bottom: 1.5rem;
  padding-left: 1.5rem;
  font-family: "Roboto", "Helvetica", "Arial", sans-serif;
  min-width: 25rem;
}


.popup-content h2 {
    font-size: 1.25rem;
    margin: 0;
    margin-top: 0.5rem;
  }


.popup-content .popup-header {
    margin-bottom: 5px;
    display: grid;
    grid-template-columns: auto 30px;
  }


.popup-content .back-button {
    color: var(--darkgrey);
    background-color: transparent;
    border-radius: 0.2rem;
    border: 1px solid var(--shell-bg-color);
    font-size: 1rem;
    padding: 0.25rem 0.5rem;
    cursor: pointer;
  }


.popup-content .back-button:hover {
    background-color: var(--grey2);
    border-color: var(--shell-bg-color);
  }


.popup-content .back-button > svg {
    margin-right: 0px;
    width: inherit;
  }

.popup-body {
  padding-right: 0.5rem;
  display: block;

}

.popup-body textarea {
    resize: none;
    margin-right: 0.5rem
  }

.popup-overlay {
  background-color: rgba(66, 66, 66, 0.5);

}

.popup-content-value {
  display: grid;
  grid-template-columns: auto 2rem;
}

.popup-content-value button {
    background-color: var(--white);
    border: 1px solid var(--border-dark-color);
    color: var(--black);
    font-size: 1rem;
    padding: 0.25rem 0.5rem;
    cursor: pointer;
    height: 100%;
  }

.popup-content-value button:hover {
      background-color: var(--grey2);
    }

.popup-content-label {
  margin-bottom: 0.5rem;
}



@media (max-width: 48rem) {
  .popup-content {
    min-width: calc(100% - 6rem);
  }

  .popup-content-value {
    display: flex;
    flex-direction: column;
    grid-template-columns: auto 2rem;

  }

    .popup-content-value textarea {
      margin: 0;
      height: 4rem;
      overflow-y: hidden;
    }

    .popup-content-value button {
      margin-top: 1rem;
      width: 100%;
      justify-content: center;
    }
}
`, "",{"version":3,"sources":["webpack://./core/components/quizzes/QuizCodePopup.css"],"names":[],"mappings":"AAGA;EACE,uCAAuC;EACvC,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;EACtB,oBAAoB;EACpB,uDAAuD;EACvD,gBAAgB;AAiClB;;;AA/BE;IACE,kBAAkB;IAClB,SAAS;IACT,kBAAkB;EACpB;;;AAEA;IACE,kBAAkB;IAClB,aAAa;IACb,gCAAgC;EAClC;;;AAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,qBAAqB;IACrB,uCAAuC;IACvC,eAAe;IACf,uBAAuB;IACvB,eAAe;EACjB;;;AAEA;IACE,8BAA8B;IAC9B,mCAAmC;EACrC;;;AAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;AAGF;EACE,qBAAqB;EACrB,cAAc;;AAOhB;;AALE;IACE,YAAY;IACZ;EACF;;AAIF;EACE,uCAAuC;;AAEzC;;AAEA;EACE,aAAa;EACb,gCAAgC;AAelC;;AAbE;IACE,8BAA8B;IAC9B,0CAA0C;IAC1C,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,eAAe;IACf,YAAY;EAKd;;AAHE;MACE,8BAA8B;IAChC;;AAIJ;EACE,qBAAqB;AACvB;;;;AAIA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,gCAAgC;;EAclC;;IAZE;MACE,SAAS;MACT,YAAY;MACZ,kBAAkB;IACpB;;IAEA;MACE,gBAAgB;MAChB,WAAW;MACX,uBAAuB;IACzB;AAGJ","sourcesContent":["@import \"../shared.css\";\r\n\r\n\r\n.popup-content {\r\n  background-color: var(--shell-bg-color);\r\n  box-shadow: var(--shadow);\r\n  padding-right: 1rem;\r\n  padding-top: 1rem;\r\n  padding-bottom: 1.5rem;\r\n  padding-left: 1.5rem;\r\n  font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n  min-width: 25rem;\r\n\r\n  h2 {\r\n    font-size: 1.25rem;\r\n    margin: 0;\r\n    margin-top: 0.5rem;\r\n  }\r\n\r\n  .popup-header {\r\n    margin-bottom: 5px;\r\n    display: grid;\r\n    grid-template-columns: auto 30px;\r\n  }\r\n\r\n  .back-button {\r\n    color: var(--darkgrey);\r\n    background-color: transparent;\r\n    border-radius: 0.2rem;\r\n    border: 1px solid var(--shell-bg-color);\r\n    font-size: 1rem;\r\n    padding: 0.25rem 0.5rem;\r\n    cursor: pointer;\r\n  }\r\n\r\n  .back-button:hover {\r\n    background-color: var(--grey2);\r\n    border-color: var(--shell-bg-color);\r\n  }\r\n\r\n  .back-button>svg {\r\n    margin-right: 0px;\r\n    width: inherit;\r\n  }\r\n}\r\n\r\n.popup-body {\r\n  padding-right: 0.5rem;\r\n  display: block;\r\n\r\n  textarea {\r\n    resize: none;\r\n    margin-right: 0.5rem\r\n  }\r\n\r\n}\r\n\r\n.popup-overlay {\r\n  background-color: rgba(66, 66, 66, 0.5);\r\n\r\n}\r\n\r\n.popup-content-value {\r\n  display: grid;\r\n  grid-template-columns: auto 2rem;\r\n\r\n  button {\r\n    background-color: var(--white);\r\n    border: 1px solid var(--border-dark-color);\r\n    color: var(--black);\r\n    font-size: 1rem;\r\n    padding: 0.25rem 0.5rem;\r\n    cursor: pointer;\r\n    height: 100%;\r\n\r\n    &:hover {\r\n      background-color: var(--grey2);\r\n    }\r\n  }\r\n}\r\n\r\n.popup-content-label {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n\r\n\r\n@media (max-width: 48rem) {\r\n  .popup-content {\r\n    min-width: calc(100% - 6rem);\r\n  }\r\n\r\n  .popup-content-value {\r\n    display: flex;\r\n    flex-direction: column;\r\n    grid-template-columns: auto 2rem;\r\n\r\n    textarea {\r\n      margin: 0;\r\n      height: 4rem;\r\n      overflow-y: hidden;\r\n    }\r\n\r\n    button {\r\n      margin-top: 1rem;\r\n      width: 100%;\r\n      justify-content: center;\r\n    }\r\n\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
